import { useCallback } from 'react';

/**
 * Custom hook for handling URL-based photo selection
 * @param {Function} setSelectedPhoto - Function to set the selected photo
 * @returns {Object} Photo selection functions
 */
const useUrlPhotoSelection = setSelectedPhoto => {
  const handlePhotosLoaded = useCallback(
    photos => {
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const photoid = urlParams.get('photoid');
        if (photoid) {
          const photoToOpen = photos.find(photo => photo.photo_id === photoid);
          if (photoToOpen) {
            setSelectedPhoto(photoToOpen);
            return;
          }
        }
        // If there is no photoid in the URL (or it no longer matches),
        // ensure any previous selection is cleared so the sidebar closes.
        setSelectedPhoto(null);
      }
    },
    [setSelectedPhoto]
  );

  return { handlePhotosLoaded };
};

export default useUrlPhotoSelection;
